export default __webpack_public_path__ + "static/media/PF_00.a6af2058.png";